import { render, staticRenderFns } from "./BusinessMemberPrescriptionDeleteProgram.vue?vue&type=template&id=17fb6605"
import script from "./BusinessMemberPrescriptionDeleteProgram.vue?vue&type=script&lang=js"
export * from "./BusinessMemberPrescriptionDeleteProgram.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports